import { render } from "./NewsPost.vue?vue&type=template&id=413bdae4&scoped=true"
import script from "./NewsPost.vue?vue&type=script&lang=js"
export * from "./NewsPost.vue?vue&type=script&lang=js"

import "./NewsPost.vue?vue&type=style&index=0&id=413bdae4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413bdae4"]])

export default __exports__